import { render, staticRenderFns } from "./lawsuit_serve.vue?vue&type=template&id=2b4d7032&scoped=true"
import script from "./lawsuit_serve.vue?vue&type=script&lang=js"
export * from "./lawsuit_serve.vue?vue&type=script&lang=js"
import style0 from "./lawsuit_serve.vue?vue&type=style&index=0&id=2b4d7032&prod&scoped=true&lang=less"
import style1 from "./lawsuit_serve.vue?vue&type=style&index=1&id=2b4d7032&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d7032",
  null
  
)

export default component.exports